import { Injectable } from "@angular/core";
import { XsHttpApiService } from "../../common/services/xs-http-api.service";
import { XsAppConfigService } from "../../common/services/xs-app-config.service";
import { PlusdCommonService } from "./plusd-common.service";

@Injectable({
  providedIn: "root"
})

export class ArchivoService {
  constructor(
    public xsHttpApiService: XsHttpApiService,
    public xsAppConfigService: XsAppConfigService,
    public plusdCommonService: PlusdCommonService,
  ) { }

  /*eliminar(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/archivo/eliminar",
      parametro
    );
  }

  agregarArchivo0(formData: FormData, archivo: any): any {
    return new Promise((resolve, reject) => {
      try {
        formData.append("file", archivo);
        formData.append("audCreadoPor", this.xsAppConfigService.APLICACION_USUARIO_WINDOWS);
        resolve(formData);
      } catch (err) {
        reject(err);
      }
    }).then(form => {
      return this.xsHttpApiService.postWithHeader(
        this.plusdCommonService.APPLICATION_API_HOST,
        "/archivo/agregar-alfresco",
        form,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );
    });
  }

  modificarArchivo(formData: FormData, archivo: any): any {
    return new Promise((resolve, reject) => {
      try {
        formData.append("file", archivo);
        formData.append("audModificadoPor", this.xsAppConfigService.APLICACION_USUARIO_WINDOWS);
        resolve(formData);
      } catch (err) {
        reject(err);
      }
    }).then(form => {
      return this.xsHttpApiService.postWithHeader(
        this.plusdCommonService.APPLICATION_API_HOST,
        "/archivo/modificar-alfresco",
        form,
        {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        }
      );
    });
  }

  eliminarArchivo(parametro): any {
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/archivo/eliminar-alfresco",
      parametro
    );
  }

  // REST API
  agregarArchivo(parametro): any {
    let aud = this.xsAppConfigService.APLICACION_USUARIO_WINDOWS;
    if (!aud) {
      aud = "default-user";
    }
    parametro.audCreadoPor = aud;
    parametro.audModificadoPor = aud;
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/archivo/agregar-alfresco",
      parametro
    );
  }

  consultarArchivo(parametro): any {
    parametro.entorno = this.xsAppConfigService.ENTORNO;
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/archivo/consultar-alfresco",
      parametro
    );
  }

  eliminarDatosNull(parametro): any {
    parametro.entorno = this.xsAppConfigService.ENTORNO;
    return this.xsHttpApiService.post(
      this.plusdCommonService.APPLICATION_API_HOST,
      "/archivo/eliminar-datos-null",
      parametro
    );
  }*/
}
